module.exports = __webpack_public_path__ + "static/media/user.62d0a372.svg";